/**
 * Custom n8n Chat Widget Entry Point
 *
 * Custom Vue-based chat UI that replaces the default n8n chat widget
 */
import { createApp } from 'vue'
import App from './App.vue'

/**
 * Initialize custom chat widget
 */
function initializeCustomChatWidget() {
  // Don't initialize in admin area
  if (document.body.classList.contains('wp-admin')) {
    return
  }

  // Create mount point if it doesn't exist
  let mountPoint = document.getElementById('cnfltd-custom-chat')
  if (!mountPoint) {
    mountPoint = document.createElement('div')
    mountPoint.id = 'cnfltd-custom-chat'
    document.body.appendChild(mountPoint)
  }

  // Create and mount Vue app
  const app = createApp(App)
  app.mount(mountPoint)

  console.info('[Conflated Domains] Custom chat widget initialized')
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCustomChatWidget)
} else {
  // DOM already loaded
  initializeCustomChatWidget()
}
